import React from 'react';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './ConfirmSendWelcomeMessageModal.scss';

type Props = {
  closeModal: Function;
  onConfirm: () => void;
};

const ConfirmSendWelcomeMessageModal = (props: Props) => {
  const { closeModal, onConfirm } = props;

  const okHandler = () => {
    onConfirm();
    closeModal();
  };

  return (
    <div className="confirm-send-welcome-message-modal">
      <ModalHeader>Send Welcome Message</ModalHeader>
      <ModalBody>
        <p>
          This will send your Welcome Message to everyone who has messaged your
          page in the past.
        </p>
        <p>Please allow 5-10 minutes for the message to process.</p>
      </ModalBody>
      <ModalFooter>
        <Button
          className="confirm-send-welcome-message-modal__btn"
          onClick={okHandler}
        >
          OK
        </Button>
        <Button
          red
          className="confirm-send-welcome-message-modal__btn"
          onClick={closeModal}
        >
          Cancel
        </Button>
      </ModalFooter>
    </div>
  );
};

export default ConfirmSendWelcomeMessageModal;
